import React from "react";

const GoogleDriveIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_961_148)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.36082 15.7835L3.15464 17.1546C3.31959 17.4433 3.55668 17.6701 3.83505 17.8351C4.63239 16.823 5.18729 16.0463 5.50003 15.5051C5.81735 14.9559 6.20737 14.0968 6.6701 12.9279C5.42304 12.7637 4.47805 12.6816 3.83512 12.6816C3.21799 12.6816 2.273 12.7637 1 12.9279C1 13.2474 1.08248 13.567 1.24743 13.8557L2.36082 15.7835Z",
  fill: "#0066DA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.1648 17.8351C16.4432 17.6701 16.6803 17.4433 16.8452 17.1547L17.1751 16.5877L18.7525 13.8557C18.9144 13.5733 18.9997 13.2534 18.9998 12.9279C17.7195 12.7637 16.7762 12.6816 16.17 12.6816C15.5185 12.6816 14.5752 12.7637 13.3401 12.9279C13.7973 14.1032 14.1822 14.9623 14.4948 15.5051C14.81 16.0528 15.3666 16.8294 16.1648 17.8351Z",
  fill: "#EA4335"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.99984 7.15462C10.9223 6.04053 11.5581 5.18139 11.9071 4.57734C12.1881 4.09092 12.4974 3.31426 12.8349 2.24741C12.5565 2.08246 12.237 1.99998 11.9071 1.99998H8.09263C7.76273 1.99998 7.44323 2.0928 7.16479 2.24741C7.59412 3.47098 7.95848 4.34179 8.25772 4.85978C8.58847 5.43226 9.16918 6.19719 9.99984 7.15462Z",
  fill: "#00832D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.33 12.9279H6.67018L3.83521 17.8351C4.1135 18 4.43307 18.0825 4.76297 18.0825H15.2372C15.5671 18.0825 15.8867 17.9897 16.165 17.835L13.33 12.9279Z",
  fill: "#2684FC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 7.15462L7.16502 2.24748C6.88659 2.41243 6.64949 2.63919 6.48454 2.92789L1.24743 12C1.08551 12.2825 1.00021 12.6023 1 12.9279H6.6701L10 7.15462Z",
  fill: "#00AC47"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.1341 7.46392L13.5155 2.92782C13.3506 2.63912 13.1135 2.41236 12.8351 2.24741L10.0001 7.15462L13.33 12.9279H18.9898C18.9898 12.6082 18.9073 12.2887 18.7424 12L16.1341 7.46392Z",
  fill: "#FFBA00"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_961_148"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 16.0825,
  fill: "white",
  transform: "translate(1 2)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleDriveIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;